import { FallbackProps } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';

import { PageButtons } from 'library/components/controls/buttons/PageButtons';
import { ApplicationInsightsTrackerException } from 'library/components/track/ApplicationInsightsTrackerException';
import { home_HomeUrl } from 'main/routes/urls/RouteUrls';

import { ErrorContent } from './ErrorContent';
import { toError } from './toError';

export type ErrorFallbackProps = Pick<FallbackProps, 'error'>;

export const ErrorFallback = (props: ErrorFallbackProps) => {
	const { t } = useTranslation(['error', 'home']);

	return (
		<ErrorContent
			description={t('error:contact-support')}
			subtitle={t('error:application-crash')}
			title={t('error:unauthenticated-title')}>
			<>
				<PageButtons
					primaryButtonLabel={t('home:root-title')}
					primaryButtonAction={() => {
						window.location.href = home_HomeUrl;
					}}
					withDivider={false}
				/>
				<ApplicationInsightsTrackerException
					metric={{ exception: toError(props.error) }}
				/>
			</>
		</ErrorContent>
	);
};
